<div
  [class.items-center]="isShort()"
  [class.items-start]="isLong()"
  class="flex gap-3">
  <ng-content />

  <label [htmlFor]="inputId()">
    <ng-content select="[label]" />
  </label>
</div>
